export const sortDates = (dateStrings) => {
  return dateStrings.sort((a, b) => new Date(a) - new Date(b));
};
